module.exports = __webpack_public_path__ + "img/orioles.0238af1c.svg";